<template>
  <b-modal
    v-model="isShown"
    title="Confirmar exclusão"
    centered
    hide-footer
    hide-header-close
    size="md"
    no-close-on-backdrop
    no-close-on-esc
  >
    <p class="cdm-message">{{ message }}</p>

    <div v-if="variables.length > 0 || restrictions.length > 0" class="cdm-children-block">
      <p class="cdm-children-title">
        <b-icon icon="exclamation-triangle-fill" class="mr-1" />
        As seguintes configurações também serão excluídas:
      </p>

      <div v-if="variables.length > 0" class="cdm-group">
        <span class="cdm-group-title">Variáveis</span>
        <ul class="cdm-children-list">
          <li v-for="(v, i) in variables" :key="'v-' + i" class="cdm-children-item">{{ v }}</li>
        </ul>
      </div>

      <div v-if="restrictions.length > 0" class="cdm-group">
        <span class="cdm-group-title cdm-group-title--restriction">Restrições</span>
        <ul class="cdm-children-list">
          <li v-for="(r, i) in restrictions" :key="'r-' + i" class="cdm-children-item cdm-children-item--restriction">{{ r }}</li>
        </ul>
      </div>
    </div>

    <div class="cdm-actions">
      <button class="cdm-btn cdm-btn--cancel" @click="handleCancel">Cancelar</button>
      <button class="cdm-btn cdm-btn--confirm" @click="handleConfirm">Excluir</button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmDeleteModal',

  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, default: '' },
    variables: { type: Array, default: () => [] },
    restrictions: { type: Array, default: () => [] },
  },

  emits: ['confirm', 'cancel'],

  computed: {
    isShown: {
      get() { return this.visible; },
      set(val) { if (!val) this.$emit('cancel'); },
    },
  },

  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.cdm-message {
  font-size: 0.85rem;
  color: #374151;
  margin-bottom: 12px;
}

.cdm-children-block {
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
  padding: 8px 10px;
  margin-bottom: 16px;
  max-height: 220px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cdm-children-block::-webkit-scrollbar {
  width: 4px;
}

.cdm-children-block::-webkit-scrollbar-track {
  background: transparent;
}

.cdm-children-block::-webkit-scrollbar-thumb {
  background-color: #fca5a5;
  border-radius: 4px;
}

.cdm-children-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: #b91c1c;
  margin: 0;
}

.cdm-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cdm-group-title {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
}

.cdm-group-title--restriction {
  color: #c2410c;
}

.cdm-children-list {
  margin: 0;
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cdm-children-item {
  font-size: 0.75rem;
  color: #374151;
  padding: 2px 6px;
  border-radius: 3px;
  background-color: #fee2e2;
}

.cdm-children-item--restriction {
  background-color: #ffedd5;
  color: #92400e;
}

.cdm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 4px;
}

.cdm-btn {
  padding: 6px 16px;
  border: none;
  border-radius: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 150ms;
}

.cdm-btn--cancel {
  background-color: #e5e7eb;
  color: #374151;
}

.cdm-btn--cancel:hover { background-color: #d1d5db; }

.cdm-btn--confirm {
  background-color: #ef4444;
  color: #ffffff;
}

.cdm-btn--confirm:hover { background-color: #dc2626; }
</style>
